import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { ConfigPedidoModule } from '../../../../configuracoes/app/pedido';
import { PedidoDRPLucroLiquidoBadgeModule } from '../../../drp/components/lucro-liquido-badge';

import { PedidoNaoLiberadoCardInfoLucroLiquidoAbaixoComponent } from './pedido-nao-liberado-card-info-lucro-liquido-abaixo.component';

@NgModule({
    imports: [
        SharedModule,
        ConfigPedidoModule,
        PedidoDRPLucroLiquidoBadgeModule
    ],
    declarations: [
        PedidoNaoLiberadoCardInfoLucroLiquidoAbaixoComponent
    ],
    exports: [
        PedidoNaoLiberadoCardInfoLucroLiquidoAbaixoComponent
    ]
})
export class PedidoNaoLiberadoCardInfoLucroLiquidoAbaixoModule { }
